module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/screen-macbook-casestudy@2x-9b60480b0f2a446257463578318d96d2.png";